"use strict";

//Menu toggle
let menu_toggle = document.querySelector(".main-menu-toggle");
menu_toggle.addEventListener("click", (e) => {
  e.preventDefault();
  document.body.classList.toggle("nav-open");
  menu_toggle.ariaExpanded =
    menu_toggle.ariaExpanded == "false" ? "true" : "false";
});

let menu_close = document.querySelector("#navMenu").querySelector(".close");
menu_close.addEventListener("click", (e) => {
  e.preventDefault();
  document.body.classList.remove("nav-open");
  menu_toggle.ariaExpanded = "false";
});
